export const readFileAsDataUrl = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()

    reader.onload = () => {
      resolve(reader.result)
    }

    reader.onerror = () => {
      reject(new Error('Unable to read the selected image file.'))
    }

    reader.readAsDataURL(file)
  })
}

export const dataUrlToFile = (
  dataUrl,
  fileName = 'captured.jpg',
) => {
  const [header, base64Data] = dataUrl.split(',')

  const mime = header.match(/:(.*?);/)?.[1] || 'image/jpeg'

  const binaryString = atob(base64Data)

  const bytes = new Uint8Array(binaryString.length)

  for (let index = 0; index < binaryString.length; index += 1) {
    bytes[index] = binaryString.charCodeAt(index)
  }

  const blob = new Blob([bytes], { type: mime })

  return new File([blob], fileName, {
    type: mime,
  })
}